import React, { useState, useEffect } from 'react';
import './Contact.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [form, setForm] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const mailtoLink = `mailto:rdoshi1997@gmail.com?subject=Enquiry from ${form.name}&body=Name: ${form.name}%0D%0AEmail: ${form.email}%0D%0AMessage: ${form.message}`;
    window.location.href = mailtoLink;
  };
  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <h2 data-aos="fade-up">Contact Me</h2>
        <p className="contact-intro" data-aos="fade-up" data-aos-delay="100">
          Have a project or event? Send me a message and let's make something amazing together.
        </p>

        <form className="contact-form" onSubmit={handleSubmit} data-aos="fade-up" data-aos-delay="200">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            value={form.name}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            value={form.email}
            onChange={handleChange}
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            required
            value={form.message}
            onChange={handleChange}
          ></textarea>
          <button type="submit">Send Message ✉️</button>
        </form>

        <div className="contact-socials" data-aos="fade-up" data-aos-delay="300">
          <p>Or connect with me:</p>
          <a
            href="https://www.instagram.com/rishabbh_doshi_creations/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link instagram"
          >
            <FaInstagram className="social-icon" /> Instagram
          </a>
          <a
            href="https://www.linkedin.com/feed/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link linkedin"
          >
            <FaLinkedin className="social-icon" /> LinkedIn
          </a>
          <a
            href="https://wa.me/919082688403?text=Hi%2C%20I%27m%20interested%20in%20your%20photography%20and%20videography%20services.%20Could%20you%20please%20share%20more%20details%3F"
            className="social-link whatsapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp className="social-icon" /> Whatsapp
          </a>
        </div>
        <div className="contact-address" data-aos="fade-up" data-aos-delay="400">
          <h3>Visit Our Studio 📍</h3>
          <address>
            2nd Floor, Shop No. 168, Raghuleela Mega Mall,<br />
            Boraspada Road, Kandivali, Sector 5 Charkop,<br />
            Kandivali West, Mumbai, Maharashtra 400067
          </address>
        </div>
      </div>
    </section>
  );
};
export default Contact;